var _style, _path, _path2, _circle, _path3, _g, _path4, _g2, _g3, _g4, _g5, _path5, _g6, _path6, _path7, _path8, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg03Heating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 214.445,
    height: 181.376,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st791{opacity:.25;fill:#f26101}.st792{fill:#fa9600}.st794{fill:#3a342c}.st797{fill:#e6e1db}.st798{fill:#f4f2ef}.st800{fill:#f2f0ed}.st801{fill:#a67c52}.st804{fill:#c7b299}.st805{fill:#e5e1dc}")), /*#__PURE__*/React.createElement("path", {
    d: "M18.404 70.381c8.834 25.172 56.468 11.442 56.591 38.569.146 32.181 10.461 73.134 45.808 64.043 30.518-7.849 21.639-44.479 47.631-52.815 13.535-4.34 48.155 4.905 45.906-33.591-1.128-19.308 1.459-26.261-11.756-38.342-25.768-23.555-47.014-4.231-75.916-8.183-26.617-3.639-41.956-47.341-72.769-39.008-29.914 8.09-45.773 40.04-35.495 69.327z",
    id: "path1049",
    style: {
      fill: "#ecf0f1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1199",
    transform: "translate(-1087.759 -758.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1051",
    style: {
      fill: "#3f3830"
    },
    d: "M1126.336 856.322h83.361v65.604h-83.361z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st791",
    d: "M1138.576 939.512c.79.009 1.578.021 2.361.03 6.281.069 12.52-.594 18.805-.594 7.102 0 14.201.025 21.302.132 5.432.082 11.141-.59 16.576.049 8.403-7.911 13.657-19.129 13.657-31.581 0-23.958-19.422-43.379-43.379-43.379-23.958 0-43.379 19.422-43.379 43.379-.001 12.651 5.418 24.034 14.057 31.964z",
    id: "path1053"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st791",
    d: "M1144.693 933.958c.625.007 1.248.017 1.867.023 4.967.054 9.901-.469 14.871-.469 5.616 0 11.229.02 16.845.104 4.295.065 8.81-.466 13.108.039 6.645-6.256 10.8-15.127 10.8-24.973 0-18.945-15.358-34.303-34.303-34.303-18.945 0-34.303 15.358-34.303 34.303 0 10.004 4.283 19.005 11.115 25.276z",
    id: "path1055"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1167.892 907.46)",
    className: "st791",
    cx: 1167.897,
    cy: 907.443,
    id: "ellipse1057",
    r: 25.094
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1063"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st792",
    d: "M1150.28 923.613c-1.236-1.71-6.222-9.013-4.963-18.976.916-7.253 4.659-12.096 6.303-13.992l4.175 11.281c.216-3.059.9-8.117 3.309-13.555 3.19-7.201 7.668-11.152 9.926-12.877 1.953 2.26 4.872 6.192 7.135 12.011 2.258 5.804 2.916 11.053 3.123 14.337 1.12-.684 3.011-2.074 4.631-4.66 2.409-3.845 2.709-7.923 2.757-9.488 1.461 2.094 9.527 14.064 5.49 27.373-1.09 3.592-2.811 6.46-4.483 8.631a88.471 88.471 0 0 1-37.403-.085z",
    id: "path1059"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1154.057 924.413c-.782-.868-4.594-5.282-3.971-11.577.449-4.534 2.954-7.572 3.971-8.682l4.413 7.029c.172-1.866.72-4.952 2.648-8.269 2.552-4.393 6.136-6.803 7.943-7.856 1.563 1.379 3.899 3.778 5.709 7.327a23.495 23.495 0 0 1 2.499 8.746c.896-.417 2.41-1.265 3.706-2.843a9.766 9.766 0 0 0 2.206-5.788c.795.98 5.765 7.318 3.677 14.884-.792 2.871-2.338 4.968-3.529 6.277a67.62 67.62 0 0 1-29.272.752z",
    id: "path1061",
    style: {
      fill: "#fabd4a"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1083"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st792",
    d: "M1145.668 870.946a1.675 1.675 0 1 0-3.35 0 1.675 1.675 0 0 0 3.35 0z",
    id: "path1065"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st792",
    cx: 1197.563,
    cy: 864.55,
    r: 0.721,
    id: "circle1067"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st792",
    d: "M1183.972 879.471a1.675 1.675 0 1 1 3.35 0 1.675 1.675 0 0 1-3.35 0z",
    id: "path1069"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st792",
    d: "M1176.503 869.749a1.197 1.197 0 1 0-2.394 0 1.197 1.197 0 0 0 2.394 0z",
    id: "path1071"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st792",
    cx: 1159.449,
    cy: 879.471,
    r: 0.949,
    id: "circle1073"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st792",
    d: "M1141.175 888.008a1.117 1.117 0 1 0-2.234 0 1.117 1.117 0 0 0 2.234 0z",
    id: "path1075"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st792",
    d: "M1197.59 897.172a1.037 1.037 0 1 1-2.073 0 1.037 1.037 0 0 1 2.073 0z",
    id: "path1077"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st792",
    d: "M1139.575 899.692a.887.887 0 1 1-1.774 0 .887.887 0 0 1 1.774 0z",
    id: "path1079"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st792",
    d: "M1182.035 889.641a.887.887 0 1 1-1.774 0 .887.887 0 0 1 1.774 0z",
    id: "path1081"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st794",
    id: "rect1085",
    d: "M1126.336 919.613h83.361v14.237h-83.361z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon1087",
    style: {
      fill: "#cdc3b6"
    },
    d: "M1120.278 856.322v77.528h6.058v-77.528h83.362v78.227h6.058V850.34H1120.278z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1117"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g1101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st794",
    id: "rect1091",
    d: "M1138.689 912.569h2.487v20.549h-2.487z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st794",
    id: "rect1093",
    d: "M1152.881 912.569h2.487v20.549h-2.487z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st794",
    id: "rect1095",
    d: "M1167.315 912.569h2.487v20.549h-2.487z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st794",
    id: "rect1097",
    d: "M1181.486 912.569h2.487v20.549h-2.487z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st794",
    id: "rect1099",
    d: "M1195.309 912.509h2.487v20.549h-2.487z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g1113"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st794",
    d: "m1141.95 911.202-1.857-4.232a.176.176 0 0 0-.323 0l-1.857 4.232a.194.194 0 0 0-.016.075c.01 2.525.924 4.597 2.034 4.597 1.11 0 2.024-2.071 2.034-4.597a.126.126 0 0 0-.015-.075z",
    id: "path1103"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st794",
    d: "m1156.142 911.202-1.857-4.232a.176.176 0 0 0-.323 0l-1.857 4.232a.194.194 0 0 0-.016.075c.01 2.525.924 4.597 2.034 4.597 1.11 0 2.024-2.071 2.034-4.597a.126.126 0 0 0-.015-.075z",
    id: "path1105"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st794",
    d: "m1170.576 911.202-1.857-4.232a.176.176 0 0 0-.323 0l-1.857 4.232a.194.194 0 0 0-.016.075c.01 2.525.924 4.597 2.034 4.597 1.11 0 2.024-2.071 2.034-4.597 0-.025 0-.051-.015-.075z",
    id: "path1107"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st794",
    d: "m1184.747 911.202-1.857-4.232a.176.176 0 0 0-.323 0l-1.857 4.232a.194.194 0 0 0-.016.075c.01 2.525.924 4.597 2.034 4.597 1.11 0 2.024-2.071 2.034-4.597a.126.126 0 0 0-.015-.075z",
    id: "path1109"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st794",
    d: "m1198.571 911.142-1.857-4.232a.176.176 0 0 0-.323 0l-1.857 4.232a.194.194 0 0 0-.016.075c.01 2.525.924 4.597 2.034 4.597 1.11 0 2.024-2.071 2.034-4.597.001-.025-.01-.051-.015-.075z",
    id: "path1111"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "rect1115",
    style: {
      fill: "#574d41"
    },
    d: "M1126.336 926.926h83.361v6.924h-83.361z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1135"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g1123"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st797",
    id: "rect1119",
    d: "M1096.114 922.843h25.364v11.007h-25.364z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st798",
    d: "M1121.478 922.843h-25.364l1.246-3.23h22.919l1.199 3.23z",
    id: "path1121"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g1129"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st797",
    id: "rect1125",
    d: "M1214.32 923.542h25.364v11.007h-25.364z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st798",
    d: "M1239.684 923.542h-25.364l1.246-3.23h22.919l1.199 3.23z",
    id: "path1127"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "polygon1131",
    style: {
      fill: "#eae5df"
    },
    d: "M1097.31 830.04v16.232h.049v73.341h22.919v-73.341h95.288v74.039h22.919V830.04h-141.126z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st797",
    d: "m1117.981 846.272 2.281 4.068h95.243l2.281-4.068h-99.805z",
    id: "path1133"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g1145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st797",
    d: "m1167.879 821.491-76.89-.015.883 1.876h152.015l.883-1.876-76.891.015z",
    id: "path1137"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st800",
    d: "M1247.738 819.054H1088.021a.262.262 0 0 0-.262.262v2.227c0 .145.117.262.262.262H1247.739a.262.262 0 0 0 .262-.262v-2.227a.263.263 0 0 0-.263-.262z",
    id: "path1139"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st797",
    d: "M1168.09 828.206H1096.147l1.133 1.833H1238.479l1.133-1.833z",
    id: "path1141"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st800",
    d: "M1168.137 823.353h-76.265l1.591 3.246a2.872 2.872 0 0 0 2.578 1.608h143.675a2.87 2.87 0 0 0 2.578-1.608l1.591-3.246z",
    id: "path1143"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st798",
    d: "M1246.28 940.191h-156.765a.395.395 0 0 1-.395-.395v-5.55c0-.218.177-.395.395-.395h156.765c.218 0 .395.177.395.395v5.55a.395.395 0 0 1-.395.395z",
    id: "path1147"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1195"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st801",
    d: "M1174.221 818.995h-15.646v-1.25c0-.223.181-.404.404-.404h14.838c.223 0 .404.181.404.404z",
    id: "path1151"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1193"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st801",
    id: "rect1153",
    d: "M1162.682 814.751h.483v2.59h-.483z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1155.894 812.068a200.734 200.734 0 0 0 22.183.734 38.202 38.202 0 0 1-11.936 1.249 38.169 38.169 0 0 1-10.247-1.983z",
    id: "path1155",
    style: {
      fill: "#7d5d3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.987 813.096c2.712.781 4.536 1.55 5.729 2.13.118.057 1.241.605 2.791 1.175 0 0 1.006.37 2.461.698 1.495.337 2.057.308 2.461 0 .31-.236.42-.554.477-.698.295-.734 1.156-1.701 3.636-2.718a101.67 101.67 0 0 1-17.555-.587z",
    id: "path1157",
    style: {
      fill: "#dbcbba"
    }
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g1189"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st804",
    d: "m1150.493 810.273 15.818-19.772-.242 2.806-6.744 15.079-.037.008zm15.63-19.303-15.259 19.074 8.356-1.786 6.709-15z",
    id: "path1159"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1165"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st805",
    d: "m1180.905 811.48-16.429 2.828",
    id: "path1161"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st804",
    id: "polygon1163",
    d: "m1180.893 811.408.024.145-16.429 2.828-.024-.145z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st801",
    d: "M1180.905 811.48h-.01l-16.086-.624a.147.147 0 0 1-.141-.153c0-.081.065-.143.153-.141l16.086.624a.147.147 0 0 1 .141.153.145.145 0 0 1-.147.141z",
    id: "path1167"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1173"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st805",
    d: "m1162.003 809.901 7.345 4.542",
    id: "path1169"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-58.27 1165.744 812.206)",
    className: "st804",
    id: "rect1171",
    d: "M1165.602 807.854h.147v8.636h-.147z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st805",
    d: "m1164.917 795.969-14.25 14.323 8.716-1.909 5.534-12.414z",
    id: "path1175"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st805",
    d: "m1164.488 799.764-6.574 12.303 5.252-1.402 1.322-10.901z",
    id: "path1177"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st805",
    d: "M1166.9 785.931a75.503 75.503 0 0 1-1.224 14.103l8.912-8.374a23.487 23.487 0 0 1-7.688-5.729z",
    id: "path1179"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st805",
    d: "M1173.731 793.031a22.381 22.381 0 0 1-8.104 7.981 42.615 42.615 0 0 1-.636 9.574 48.613 48.613 0 0 1 5.154-.282 48.921 48.921 0 0 1 9.243.869l-5.657-18.142z",
    id: "path1181"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st801",
    d: "M1160.706 813.01a70.554 70.554 0 0 1-10.497-2.46.22.22 0 1 1 .134-.42 70.665 70.665 0 0 0 10.397 2.44.222.222 0 0 1-.034.44z",
    id: "path1183"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st801",
    d: "M1164.635 813.708h-.011a.22.22 0 0 1-.209-.231 539.475 539.475 0 0 1 2.131-28.279.218.218 0 0 1 .242-.197.22.22 0 0 1 .197.242 540.533 540.533 0 0 0-2.129 28.256.224.224 0 0 1-.221.209z",
    id: "path1185"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st801",
    d: "M1165.402 801.199a.144.144 0 0 1-.109-.049.145.145 0 0 1 .011-.207l.503-.456a121.161 121.161 0 0 0 9.08-9.229.146.146 0 0 1 .207-.013.146.146 0 0 1 .013.207 121.386 121.386 0 0 1-9.102 9.252l-.504.457a.147.147 0 0 1-.099.038z",
    id: "path1187"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1155.894 812.068c.029.147.089.346.22.551.322.498.834.656.992.698 2.154.567 3.968.882 5.252 1.065 2.828.404 6.866.947 11.753 0a28.614 28.614 0 0 0 3.746-.992l.22-.588c-3.788.584-8.52.946-13.919.514a59.67 59.67 0 0 1-8.264-1.248z",
    id: "path1191",
    style: {
      fill: "#b89675"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg03Heating);
export default __webpack_public_path__ + "static/media/03-Heating.57e58d36dded16786d05c5ac380f73c8.svg";
export { ForwardRef as ReactComponent };